import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();

    // Check token first
    if (!auth?.accessToken) {
        return <Navigate to="/logout" state={{ from: location }} replace />;
    }

    // Optional: check roles if route is role-protected
    if (allowedRoles && !auth.roles?.some(role => allowedRoles.includes(role))) {
        return <Navigate to="/notauthorized" state={{ from: location }} replace />;
    }

    return <Outlet />;
}

export { RequireAuth };